import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'phone'})
export class PhonePipe implements PipeTransform {
    transform(value: string): string {
        if(value === null) return '';
        return value.toString().replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
}



// WEBPACK FOOTER //
// ./src/app/phone.pipe.ts